import styled from "styled-components";

export const Wrapper = styled.div`
  margin: 0 auto 1rem;
  max-width: 420px;
`;

export const OverlayContainer = styled.div`
  width: 100%;
  height: 100%;
  background: rgba(32, 30, 32, 0.9);
  padding-bottom: 1em;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  text-align: center;
`;

export const BannerTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  max-width: 300px;

  margin-bottom: 1.5em;
`;

export const BannerTitle = styled.p`
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  line-height: 28px;
`;

export const BannerText = styled.p`
  margin: 0;
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
`;

export const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0;
  max-width: 420px;
  label {
    color: white;
    margin: 0.5rem 0 0;
  }
`;

export const UserInfo = styled.div`
  background-color: #201e20;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: ${(props) => (props.bottom ? "2px solid #5F5D5F" : "none")};
  padding: 0.5rem 1rem;
  margin: ${(props) => (props.space ? "0 0 1rem" : "0")};
  font-size: 14px;
`;

export const Span = styled.span`
  position: absolute;
  z-index: 1;
  cursor: text;
  pointer-events: none;
  color: #aca9b3;
  line-height: 20px;
  font-size: 12px;
  padding: 0.2rem 0.45rem 0.6rem;
`;

export const Select = styled.select`
  background-color: #100f10;
  color: #ffffff;
  border: none;
  border-radius: 5px;
  padding: 1.1rem 0.3rem 0.3rem;
  display: block;
  font-size: 16px;
  width: 100%;
  -webkit-border: none;
`;

export const Button = styled.button`
  background-color: ${(props) => (props.dark ? "#201e20" : "#ffffff")};
  color: ${(props) => (props.dark ? "#ffffff" : "#201e20")};
  border: ${(props) => (props.dark ? "1px solid #aca9b3" : "none")};
  border-radius: 5px;
  height: 49px;
  margin-top: 1rem;
  width: 100%;
  padding: 0.3rem 0;
  text-transform: uppercase;
  font-size: 14px;
  font-weight: bold;
  text-align: center;
`;

export const SubTitle = styled.div`
  font-size: 14px;
  font-weight: ${(props) => (props.dark ? 700 : 700)};
  margin: ${(props) => (props.dark ? "0 -0.7rem" : "1.8rem 0 0 0")};
  background-color: ${(props) => (props.dark ? "#100F10" : "#201e20")};
  padding: ${(props) => (props.dark ? "0.7rem 1rem" : "0 0.2rem")};
  color: ${(props) => (props.dark ? "#ACA9B3" : "ffffff")};
`;

export const Error = styled.div`
  color: #ff7651;
  font-weight: lighter;
  font-size: 12px;
`;

export const Vivo = styled.div`
  margin-top: 1.8rem;
  margin-right: 1rem;
  font-size: 12px;
  position: relative;
  display: inline-block;
  img {
    padding: 0 0.4rem;
  }
  span {
    visibility: hidden;
    width: 120px;
    background-color: #974fe3;
    color: #ffffff;
    text-align: center;
    border-radius: 6px;
    padding: 5px 0;
    position: absolute;
    top: -5px;
    right: 105%;
    z-index: 1;
  }

  :hover span {
    visibility: visible;
  }
`;

export const Contact = styled.div`
  display: flex;
  justify-content: space-between;
  max-width: 768px;
`;

export const Menu = styled.ul`
  list-style-type: none;
  display: flex;
  justify-content: space-between;
  max-width: calc(420px + 1rem);
  margin: 0.7rem auto;
  padding: 0;
  border-bottom: 1px solid #ffffff;
  position: relative;
  span {
    text-align: center;
    font-size: 12px;
    padding: 0.3rem;
    :hover {
      color: #cff16b;
    }
  }
  span.active {
    width: 110px;
    border: 1px solid #ffffff;
    border-bottom: 1px solid #201e20;
    border-radius: 5px 5px 0 0;
    font-weight: bold;
    font-size: 13px;
    z-index: 2;
    position: relative;
    top: 1px;
  }
  li {
    cursor: pointer;
    z-index: 1;
  }
  @media (min-width: 768px) {
    margin: 1rem auto;
  }
`;

export const Box = styled.div`
  border-radius: 5px;
  border: 1px solid #cff16b;
  margin: 1.5rem;
  padding: 0.5rem;
  text-align: center;
  span {
    color: #aca9b3;
  }
`;

export const SmallButton = styled.div`
  border: 1px solid #ffffff;
  text-transform: uppercase;
  color: #ffffff;
  font-size: 12px;
  font-weight: 700;
  width: 125px;
  padding: 6px 4px 4px;
  text-align: center;
  border-radius: 3px;

  i {
    font-size: 18px;
  }
`;
